/* eslint-disable @typescript-eslint/no-redeclare */
export const UPLOAD_FILE_LOADING = 'UPLOAD_FILE_LOADING';
export type UPLOAD_FILE_LOADING = typeof UPLOAD_FILE_LOADING;
